import { ThemeColors } from '~/themes/colors'

export interface ContactsListEmptyNoticeColors {
  BackgroundColor: ThemeColors
  Icon: ThemeColors
  FontColor: {
    WarningText: ThemeColors
    DescriptionText: ThemeColors
    SearchContextText: ThemeColors
  }
}

export const contactsListEmptyNoticeColors: ContactsListEmptyNoticeColors = {
  BackgroundColor: {
    default: 'gray.200',
  },
  Icon: {
    default: 'gray.600',
  },
  FontColor: {
    WarningText: {
      default: 'gray.800',
    },
    DescriptionText: {
      default: 'gray.800',
    },
    SearchContextText: {
      default: 'gray.1300',
    },
  },
}
